//
// util/uuid.ts
//
// Copyright 2025-Present Couchbase, Inc.
//
// Use of this software is governed by the Business Source License included
// in the file licenses/BSL-Couchbase.txt.  As of the Change Date specified
// in that file, in accordance with the Business Source License, use of this
// software will be governed by the Apache License, Version 2.0, included in
// the file licenses/APL2.txt.
//


/** Creates a randomized UUID string. (May not be cryptographically secure.) */
export function createRandomUUID(): string {
    return (typeof crypto !== 'undefined') ? crypto.randomUUID() : createInsecureRandomUUID();
}


/** Creates a UUID(-ish) string without using the `crypto` API. Not cryptographically secure! */
export function createInsecureRandomUUID(): string {
    const parts: string[] = [];
    for (let i = 0; i < 8; i++)
        parts.push( pseudoRandomInteger(1 << 16).toString(16).padStart(4, '0') );
    return parts.join("");
}


/** Returns a pseudo-random integer in the range 0 <= n < limit. */
export function pseudoRandomInteger(limit: number): number {
    // Fun fact: I remember writing this exact function in BASIC as a kid in 1977. --Jens
    return Math.floor(Math.random() * limit);
}
